import constants from '../constants/index';

const defaultState = {
  isOpen: false
};

export default function modalReducer(state = defaultState, action) {
  let newState = state;

  switch(action.type) {
    case constants.SHOW_MODAL:
      newState = Object.assign({}, newState, {
        isOpen: action.payload.isOpen
      });
      break;
    default:
  }
  return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/modal_reducer.js
 **/